import React, { useRef, useState } from "react";
import "./gallery.scss";
import { Col, Row } from "antd";
import {
  galleryGamesimg1,
  galleryGamesimg2,
  galleryTourimg2,
  galleryTourimg1,
  galleryTourimg7,
  galleryimg1,
  galleryimg3,
  galleryimg5,
  galleryimg6,
  galleryimg7,
  galleryimg8,
  webwrite1,
  webwrite10,
  webwrite11,
  webwrite12,
  webwrite13,
  webwrite14,
  webwrite15,
  webwrite16,
  webwrite17,
  webwrite18,
  webwrite19,
  webwrite2,
  webwrite20,
  webwrite21,
  webwrite22,
  webwrite23,
  webwrite25,
  webwrite26,
  webwrite27,
  webwrite28,
  webwrite3,
  webwrite4,
  webwrite5,
  webwrite6,
  webwrite7,
  webwrite8,
  webwrite9,
  webwrite30,
  webwrite31,
  webwrite33,
  webwrite32,
  webwrite34,
} from "../../assets/index";
import Footer from "../../components/footer/Footer";
import { useModal, useVerticalModal } from "../../config/CustomHooks";
import MainImgModal from "../../components/modal/MainImgModal";
import MainImgVerticalModal from "../../components/modal/MainImgVerticalModal";
import { useMediaQuery } from "react-responsive";
import { useEffect } from "react";
import { HashLoader } from "react-spinners";

const Gallery = () => {
  const isTablet = useMediaQuery({ query: "(max-width: 968px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 390px)" });

  const [selectedImage, setSelectedImage] = useState("");
  const [selectedVerticalImage, setSelectedVerticalImage] = useState("");
  const { isOpen, setIsOpen } = useModal(false);
  const { isVerticalOpen, setIsVerticalOpen } = useVerticalModal(false);
  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setIsOpen(true);
  };
  const handleImageVerticalClick = (imageUrl) => {
    setSelectedVerticalImage(imageUrl);
    setIsVerticalOpen(true);
  };
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2500);
  }, []);

  return (
    <>
      {loading ? (
        <div
          style={{
            backgroundColor: "#fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <HashLoader color="#0051FB" size={50} />
        </div>
      ) : (
        <>
          {isOpen ? (
            <MainImgModal
              onClose={() => setIsOpen(false)}
              src={selectedImage}
            />
          ) : null}
          {isVerticalOpen ? (
            <MainImgVerticalModal
              onClose={() => setIsVerticalOpen(false)}
              src={selectedVerticalImage}
            />
          ) : null}

          <div className="container gallery">
            {/* <div className="gallery-heading">
              <div className="gallery-heading-left">
                <h1> Gallery </h1>
                <p>
                  A healthy environment focuses on team collaboration and unity.
                  Our team understands it well!
                </p>
              </div>
            </div> */}
 
            <div className="gallery-images mt-3 mb-5">
              <Row gutter={isMobile ? [5, 5] : [10, 10]}>
                <Col span={isTablet ? 24 : 12}>
                  <Row gutter={isMobile ? [5, 5] : [10, 10]}>
                    <Col span={12}>
                      <Row gutter={isMobile ? [5, 5] : [10, 10]}>
                        <Col span={24}>
                          <img
                            src={webwrite9}
                            alt=""
                            className="galleryimgbox"
                            onClick={() => handleImageClick(webwrite9)}
                          />
                        </Col>
                        
                        <Col span={24}>
                          <img
                            src={webwrite33}
                            alt=""
                            className="galleryimgbox"
                            onClick={() => handleImageClick(webwrite33)}
                          />
                        </Col>
                      </Row>
                      
                    </Col>
                    
                    <Col span={12}>
                      <Row>
                        <Col>
                          <img
                            src={webwrite31}
                            alt=""
                            className="galleryimgVertical"
                            onClick={() => handleImageVerticalClick(webwrite31)}
                          />
                        </Col>
                      </Row>
                    </Col>
                    
                    
                 
                   
                    {/* <Col span={12}>
                      <img
                        src={webwrite12}
                        alt=""
                        className="galleryimgbox"
                        onClick={() => handleImageClick(webwrite12)}
                      />
                    </Col>
                    <Col span={12}>
                      <img
                        src={webwrite12}
                        alt=""
                        className="galleryimgbox"
                        onClick={() => handleImageClick(webwrite12)}
                      />
                    </Col> */}
                    <Col span={24}>
                      {/* <img
                        src={webwrite8}
                        alt=""
                        className="galleryimgbox"
                        onClick={() => handleImageClick(webwrite8)}
                      /> */}
                    </Col>
                    <Col span={24}>
                      <img
                        src={galleryimg1}
                        alt=""
                        className="galleryimgbox"
                        // style={{ height: "100%" }}
                        onClick={() => handleImageClick(galleryimg1)}
                      />
                    </Col>
                    <Col span={12}>
                      <img
                        src={webwrite11}
                        alt=""
                        className="galleryimgbox"
                        onClick={() => handleImageClick(webwrite11)}
                      />
                    </Col>
                    <Col span={12}>
                      <img
                        src={webwrite8}
                        alt=""
                        className="galleryimgbox"
                        onClick={() => handleImageClick(webwrite8)}
                      />
                    </Col>
                    
                    
                    <Col span={24}>
                      <img
                        src={webwrite19}
                        alt=""
                        className="galleryimgbox"
                        onClick={() => handleImageClick(webwrite19)}
                      />
                    </Col>
                
                   
                    <Col span={12}>
                      <img
                        src={galleryTourimg2}
                        alt=""
                        className="galleryimgbox"
                        onClick={() => handleImageClick(galleryTourimg2)}
                      />
                    </Col>
                    <Col span={12}>
                      <img
                        src={webwrite22}
                        alt=""
                        className="galleryimgbox"
                        onClick={() => handleImageClick(webwrite15)}
                      />
                    </Col>
                    <Col span={24}>
                      <img
                        src={webwrite2}
                        alt=""
                        className="galleryimgbox"
                        onClick={() => handleImageClick(webwrite2)}
                      />
                    </Col>
                  
                  </Row>
                </Col>
                <Col span={isTablet ? 24 : 12}>
                  <Row gutter={isMobile ? [5, 5] : [10, 10]}>
                    <Col span={12}>
                      <Row gutter={isMobile ? [5, 5] : [10, 10]}>
                        <Col span={24}>
                          <img
                            src={galleryTourimg1}
                            alt=""
                            className="galleryimgbox"
                            onClick={() => handleImageClick(galleryTourimg1)}
                          />
                        </Col>
                        <Col span={24}>
                          <img
                            src={webwrite28}
                            alt=""
                            // className="galleryimgVertical"
                            className="galleryimgbox"
                            onClick={() => handleImageVerticalClick(webwrite28)}
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Col span={12}>
                      <Row gutter={isMobile ? [5, 5] : [10, 10]}>
                        <Col span={24}>
                          <img
                            src={webwrite27}
                            alt=""
                            className="galleryimgVertical"
                            onClick={() => handleImageClick(webwrite27)}
                          />
                        </Col>
                        <Col span={24}>
                          {/* <img
                            src={webwrite10}
                            alt=""
                            className="galleryimgbox"
                            onClick={() => handleImageClick(webwrite10)}
                          /> */}
                        </Col>
                        {/* <Col span={24}>
                          <img
                            src={webwrite8}
                            alt=""
                            // className="galleryimgVertical"
                            className="galleryimgbox"
                            onClick={() => handleImageClick(webwrite8)}
                          />
                        </Col> */}
                      </Row>
                    </Col>
                    <Col span={24}>
                      <img
                        src={galleryimg8}
                        alt=""
                        className="galleryimgbox"
                        onClick={() => handleImageClick(galleryimg8)}
                      />
                    </Col>
                    <Col span={12}>
                      <img
                        src={galleryimg6}
                        alt=""
                        className="galleryimgbox"
                        onClick={() => handleImageClick(galleryimg6)}
                      />
                    </Col>
                    
                   
                    <Col span={12}>
                      <img
                        src={webwrite32}
                        alt=""
                        // className="galleryimg"
                        className="galleryimgbox"
                        onClick={() => handleImageClick(webwrite32)}
                      />
                    </Col>
                    {/* <Col span={12}>
                      <img
                        src={galleryimg8}
                        alt=""
                        className="galleryimgbox"
                        onClick={() => handleImageClick(galleryimg8)}
                      />
                    </Col> */}
                    {/* <Col span={12}>
                      <img
                        src={galleryimg8}
                        alt=""
                        className="galleryimgbox"
                        onClick={() => handleImageClick(galleryimg8)}
                      />
                    </Col> */}
                    <Col span={24}>
                      <img
                        src={webwrite18}
                        alt=""
                        // className="galleryimgVertical galleryimgVerticalLess"
                        className="galleryimgbox"
                        onClick={() => handleImageVerticalClick(webwrite18)}
                      />
                    </Col>
                    <Col span={12}>
                      <img
                        src={webwrite34}
                        alt=""
                        // className="galleryimgVertical galleryimgVerticalLess"
                        className="galleryimgbox"
                        onClick={() => handleImageVerticalClick(webwrite34)}
                      />
                    </Col>
                    
                    <Col span={12}>
                      <img
                        src={webwrite13}
                        alt=""
                        className="galleryimgbox"
                        // className="galleryimgVertical galleryimgVerticalLess"
                        onClick={() => handleImageVerticalClick(webwrite13)}
                      />
                    </Col>
                    {/* <Col span={12}>
                      <img
                        src={galleryimg7}
                        alt=""
                        className="galleryimgSquare"
                        // className="galleryimgVertical galleryimgVerticalLess"
                        onClick={() => handleImageVerticalClick(galleryimg7)}
                      />
                    </Col> */}
                    <Col span={24}>
                      <img
                        src={galleryGamesimg1}
                        alt=""
                        className="galleryimgbox"
                        // style={{ height: "27vh", objectFit: "cover" }}
                        onClick={() =>
                          handleImageVerticalClick(galleryGamesimg1)
                        }
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>

          <Footer />
        </>
      )}
    </>
  );
};

export default Gallery;
